import { ProfileTypes } from "./actionTypes"

const initialState = {
  profile: {},
  error: "",
  success: "",
}

const profile = (state = initialState, action : any) => {
  switch (action.type) {
    case ProfileTypes.GET_PROFILE_SUCCESS:
      state = { ...state, profile: action.payload }
      break
    case ProfileTypes.PROFILE_ERROR:
      state = { ...state, error: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
